import { IconMenuFold, IconMenuUnfold } from '@arco-design/web-react/icon';
import styled from '@emotion/styled';
import { useAtom } from 'jotai';
import React from 'react';
import { collapsedAtom } from '../store';

const BtnWrapper = styled.div`
  height: 24px;
  width: 24px;
  background-color: var(--color-fill-1);
  color: var(--color-text-3);
  border-radius: 2px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  // 位置
  position: absolute;
  bottom: 12px;
  right: 12px;

  &:hover {
    background-color: var(--color-fill-3);
  }
`;

export const CollapseBtn = () => {
  const [collapsed, seCollapsed] = useAtom(collapsedAtom);
  return (
    <BtnWrapper onClick={() => seCollapsed(!collapsed)}>
      {collapsed ? <IconMenuUnfold /> : <IconMenuFold />}
    </BtnWrapper>
  );
};
